export class ProgramCodesService {
    constructor(axios, apiUrl) {
      this.$axios = axios;
      this.apiUrl = apiUrl;
    }
  
    async getProgramCodeById(id, sqldbid) {
        return await this.$axios.get(
            this.apiUrl + "ProgramCodes/ProgramCode/" + id + "/Company/" + sqldbid
        ).then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }
    
    async getAllProgramCodes(sqldbid) {
      return await this.$axios.get(
          this.apiUrl + "ProgramCodes/All/" + sqldbid
      ).then(function(response) {
          return response.data;
      })
      .catch(function(error) {
          return {error: error, response: error.response.data };
      });
  }
}
